// @flow

import React, { PureComponent } from 'react';
import type { Element } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ICONS from '@automotivetech/icons/dist/static/media/icons.svg';
import AccordionItem from './AccordionItem';

import styles from './Accordion.scss';

/**
 * Accordion React component.
 */
class Accordion extends PureComponent<*, *> {
  /**
   * Accordion constructor.
   * @param {object} props to constructor.
   * @constructor
   */
  constructor(props: Object) {
    super(props);

    // Although it is usually deemed an anti-pattern to have a prop used to set state (because there
    // is then two sources of truth), in this case we want to be able to intialise the state with a seed
    // value when first mounted (e.g. when the state of the accordion is affected by the route)
    this.state = {
      activeIndex:
        this.props.activeIndexSeed !== undefined
          ? this.props.activeIndexSeed
          : -1
    };
  }

  /* eslint-disable camelcase */
  /**
   * componentWillReceiveProps implementation.
   * @param {object} nextProps - component props
   * @returns {void}
   */
  UNSAFE_componentWillReceiveProps(nextProps: Object) {
    // Also need to update the state with the seed value IF the seed value is defined and has actually changed
    if (
      nextProps.activeIndexSeed !== undefined &&
      nextProps.activeIndexSeed !== this.props.activeIndexSeed
    ) {
      this.setState({ activeIndex: nextProps.activeIndexSeed });
    }
  }

  /**
   * Click handler for Tabs sets isOpen state
   * @param  {number} activeIndex key for which tab is clicked on
   * @return {void}
   */
  handleOnClick = (activeIndex: number) => {
    const newIndex = this.state.activeIndex === activeIndex ? -1 : activeIndex;
    this.setState({
      activeIndex: newIndex
    });

    const { onClick, content } = this.props;
    /* istanbul ignore else */
    if (onClick && this.state.activeIndex === -1) {
      onClick(content[0] && content[0].accordionTitle);
    }
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render(): Element<*> {
    const { extendStyle, content, isHtml, iconColor } = this.props;

    return content.map(({ accordionTitle, childContent }, index) => {
      return (
        <div
          key={'Accordion' + index}
          className={classNames(styles.Accordion__Wrapper, extendStyle)}
          data-cy={`accordion-${index}`}
        >
          <AccordionItem
            {...this.props}
            iconOpen={`${ICONS}#wci-arrow-up`}
            iconClosed={`${ICONS}#wci-arrow-down`}
            key={'accordion' + index}
            index={index}
            isHtml={isHtml}
            accordionItemTitle={accordionTitle}
            childContent={childContent}
            onClick={this.handleOnClick}
            isOpen={this.state.activeIndex === index}
            iconColor={iconColor}
          />
        </div>
      );
    });
  }
}

Accordion.propTypes = {
  extendStyle: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  iconColor: PropTypes.string,
  isHtml: PropTypes.bool,
  activeIndexSeed: PropTypes.number,
  onClick: PropTypes.func
};

Accordion.defaultProps = {
  isHtml: false,
  iconColor: 'green'
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/FAQs/Accordion/Accordion.js